import BaseRepository from './BaseRepository';

export default class TravelAgentAssistantsRepository extends BaseRepository
{
    getEndpoint()
    {
        return 'v1/travel-agency-assistants';
    }
}
